import {
    Accordion, AccordionSummary,AccordionDetails,
    Typography,List,ListItem, Collapse,TextField,
    IconButton, Stack, Button, Snackbar,Paper
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { makeStyles } from 'tss-react/mui' ;
import { useEffect, useState } from 'react';
import ListView from './list';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Add } from '@mui/icons-material';
import CONSTANT from '../../../Constant/Constant'; 
import Storage from '../../../session/storage';
import Popup from '../error/popup';
import moment from 'moment';
import jsondata from "../../../config/ProfileDetailsData.json"
import PopUpMsg from '../../../config/popUpMsg.json';
import { sortTranslated } from '../../shared/util';

const useStyles = makeStyles()((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0)
    },
    nested: {
        paddingLeft: theme.spacing(1),
    },

}));
const IdentifiersView = (props) => {
    const classes = useStyles();
    const [modal, setModal] = useState({ flag: false });
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [changedFlag, setChangedFlag] = useState(false);
    const [accordian, setAccordian] = useState(true);
    const [addNewFlag, setaddNewFlag] = useState(props.page === 'New' ? true : false);
    const [label, setLabel] = useState(props.label);
    const [idlengthFlag, setidlengthFlag] = useState();
    const [typelengthFlag, settypelengthFlag] = useState();
    const [subtypelengthFlag, setsubtypelengthFlag] = useState();
    const [identifierId, setIdentifierId] = useState('')
    const [identifierType, setIdentifierType] = useState('')
    const [identifierSubType,setIdentifierSubType] = useState('')
    const [data] = useState(jsondata.IDENTIFIER_MANAGED_BY);
    const [identifierSaved, setIdentifierSaved] = useState(false)
    const [identifierPopUpMsg] = useState(PopUpMsg.profileDetail)
    const [showSubType, setShowSubType] = useState(true)
    //Restrict controlled inputs to 1 main source. In this case, the parent component contains state for identifiers-view.
    // const [old_value,setold_value] = useState(props.value && props.value.length > 0 ? props.value : [])
    let Options = CONSTANT.LOV_BOUNDED_OPTION.includes("Type") ? Storage.getLovBoundedList() : Storage.getPickList();    
    let AltIDSubtype = Options && Options[props.entity]["AltIDSubtype"] ?Options[props.entity]["AltIDSubtype"] :[]    

    let AltIDType = Options && Options[props.entity]["AltIDType"] ? Options[props.entity]["AltIDType"] : []     
    if (props.identifierOptions && props.identifierOptions.length > 0) {
      AltIDType = props.identifierOptions
    }

  // removed set method to get all the identifier in below variable
    let [identifierTypeOption] = useState(AltIDType ? AltIDType : []);
    const [error, setError] = useState(false);

    const [identifierValue, setIdentifierValue] = useState(props.value)
    const [oldIdentifierValue, setOldIdentifierValue] = useState(props.value)
    const [selectedIdentifier] = useState(props.value)
    const [snackBarMessage, setSnackBarMessage] = useState('')
    const [oldEffectiveEndDate, setOldEffectiveEndDate] = useState("")
    useEffect(() => {
        setLabel(props.label);
        setChangedFlag(props.change)
        setError(props.error)
        setIdentifierValue(props.value)
    }, [props.label, props.value, props.id, props.error, props.change]);

    const closeAccordian = (prev) => {
        setAccordian(!prev)
    }


    const sortIdentifier = (identiferList) => {        
        const groupedEntries = {
          classified_LillyManaged: [],
          classified__VendorManaged: [],
          unClassified_LillyManaged: [],
          unClassified__VendorManaged: [],
         
        };
  
        identiferList.forEach((entry) => {
          if (entry.includes("@@Lilly Managed")  ) {
              if(entry.includes("//")){
                  groupedEntries.unClassified_LillyManaged.push(entry);
              }
              else{
                  groupedEntries.classified_LillyManaged.push(entry);
              }
            
          } else if (entry.includes("@@Vendor Managed")) {
              if(entry.includes("//")){
                  groupedEntries.unClassified__VendorManaged.push(entry);
              }
              else{
                  groupedEntries.classified__VendorManaged.push(entry);
              }
          } else{
            if(entry.includes("//")){
                groupedEntries.unClassified__VendorManaged.push(entry);
            }
            else{
                groupedEntries.classified__VendorManaged.push(entry);
            }
          }
        });
  
        // Sort each group alphabetically
        groupedEntries.classified_LillyManaged.sort();
        groupedEntries.classified__VendorManaged.sort();
        groupedEntries.unClassified_LillyManaged.sort();
        groupedEntries.unClassified__VendorManaged.sort();
  
        // Conditionally handle missing groups
        const groupedOptions = [];
  
        if (groupedEntries.classified_LillyManaged.length > 0) {
          groupedOptions.push({ options: groupedEntries.classified_LillyManaged });
        }
        if (groupedEntries.classified__VendorManaged.length > 0) {
          groupedOptions.push({ options: groupedEntries.classified__VendorManaged });
        }
        if (groupedEntries.unClassified_LillyManaged.length > 0) {
          groupedOptions.push({ options: groupedEntries.unClassified_LillyManaged });
        }
        if (groupedEntries.unClassified__VendorManaged.length > 0) {
          groupedOptions.push({ options: groupedEntries.unClassified__VendorManaged });
        }      
        return groupedOptions
    };

    const addNewNested = (attribute) => {
        setaddNewFlag(true)
        setIdentifierSaved(false)
        props.checkIdentifierSubmitted(true,identifierType,identifierId,identifierSaved)
    }

    const deleteItemFromList = (deletevalue) => {
        let removeIndex = props.value.findIndex((el)=> el.ID[0].value === deletevalue.ID[0].value && el.ID[0].Type === deletevalue.ID[0].Type);
        const tempArr = [...props.value];
        tempArr.splice(removeIndex,1);
        props.updatedValue(tempArr,true);
    }
    const updateValue = (value, flag, key) => { 
      let addFlag = { ...value, ["Deactivated"]: true };
      if (
        addFlag["EffectiveEndDate"] &&
        addFlag["EffectiveEndDate"][0]["value"]
      ) {
        var todayDate = moment.utc(new Date()).format("YYYY-MM-DD")      
        if (
          value["Status"] &&
          value["Status"][0]["value"] &&
          value["Status"][0]["value"] == "Inactive"
        ) {
                    
            let effectiveEndDate = moment.utc(new Date(addFlag["EffectiveEndDate"][0]["value"])).format("YYYY-MM-DD")
            effectiveEndDate < todayDate ?  addFlag = { ...addFlag } : addFlag = { ...addFlag, ["EffectiveEndDate"]: [{ value: todayDate }] }
            
            if(oldIdentifierValue[key] && oldIdentifierValue[key].Status && oldIdentifierValue[key]?.Status[0]?.value === value.Status[0]?.value){
                setOldEffectiveEndDate("")
                setOldIdentifierValue((prev,i)=>prev.map((item,i)=>{
                    return key === i ? {...item, udpateFlag: false} : item
                    
                }))
            }else{
                setOldIdentifierValue((prev,i)=>prev.map((item,i)=>{
                    return key === i ? {...item, udpateFlag: true} : item
                    
                }))
                setOldEffectiveEndDate("9999-12-31")
                
            }
        } else {
          addFlag = {
            ...value,
            ["EffectiveEndDate"]: [{ value: "9999-12-31" }],
            ["Deactivated"]: true
          };
          if( oldIdentifierValue[key] && oldIdentifierValue[key].Status  && oldIdentifierValue[key]?.Status[0]?.value === value?.Status[0]?.value){
            setOldEffectiveEndDate("")
            setOldIdentifierValue((prev,i)=>prev.map((item,i)=>{
                return key === i ? {...item, udpateFlag: false} : item
                
            }))
            
        }else{
            if(oldIdentifierValue[key].EffectiveEndDate[0].value < todayDate){  
                setOldEffectiveEndDate(oldIdentifierValue[key].EffectiveEndDate[0].value)
                setOldIdentifierValue((prev,i)=>prev.map((item,i)=>{
                    return key === i ? {...item, udpateFlag: true} : item
                    
                }))
            }else{
            setOldEffectiveEndDate('')
            setOldIdentifierValue((prev,i)=>prev.map((item,i)=>{
                return key === i ? {...item, udpateFlag: true} : item
                
            }))
            
            }
        }
        }
      }
      let allIdentifier = [...identifierValue];     
      allIdentifier.splice(key, 1, addFlag);
      setIdentifierValue(allIdentifier);
      
    };
    
    const saveUpdatedIdentifier = (index) =>{ 
        props.updatedValue(identifierValue, false, index)
        setSnackBarMessage('Identifier successfully updated')
        setSnackbarOpen(true)
    }

    const noDataInIdentitifer = (message) =>{       
        setModal({
            flag: true,
            success: false,
            message: message,
            title: 'Error'
        });
    }

    const deletePreviousChange = (index)=>{
        let identifierList = [...identifierValue]          
        identifierList.splice(index, 1, selectedIdentifier[index])
        setIdentifierValue(identifierList)       
        setOldEffectiveEndDate('')
        setOldIdentifierValue((prev,i)=>prev.map((item,i)=>{
            return index === i ? {...item, udpateFlag: false} : item  })
        )
        props.updatedValue(identifierList, true, index)
        setSnackBarMessage('Identifier successfully restore')
        setSnackbarOpen(true)
    }

    const saveNewIteam = () =>{       
        if (!identifierType || identifierType.length === 0)
        {
            setModal({
                flag: true,
                success: false,
                message: 'Please select Identifier Type fields before Submitting Request !',
                title: 'Error'
            });
            setIdentifierSaved(false)

        }
        else if (!identifierId || identifierId.length  === 0)
        {
            setModal({
                flag: true,
                success: false,
                message: 'Please fill Identifier ID fields before Submitting Request !',
                title: 'Error'
            });
            setIdentifierSaved(false)
        }
        else if(props.value.filter((el)=>{ return el["ID"][0].value === identifierId && el["Type"][0].value === identifierType }).length > 0){
            setModal({
                flag: true,
                success: false,
                message: 'Please select different Identifier Type or fill different Identifier ID before saving',
                title: 'Error'
            });
            setIdentifierSaved(false)
        }else{
            // payload changes due to new formatting of identifier.
            // in type we are spliting the identifier type by '##' and pushing value of 0 index
            // adding new field 'Managed By' to route the dcr to specific source as per the identifier source 
            let newIdentifier ={
                Type: [{ value: identifierType.split('@@')[0]}],
                ID: [{ value: identifierId }],
                Status:[{ value: "Active" }],
                AddedNew:true,
                EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                EffectiveEndDate: [{ value: "9999-12-31" }],
                ManagedBy:[{ value: (identifierType?.split('@@')[1]?.includes('Lilly Managed')) ? data[0]?.Lilly : data[0]?.Vendor  }]
            } 
            // in subtype we are spliting through '|' to get rest of the part
            if (identifierSubType && identifierSubType.length >0){
                newIdentifier["SubType"] =[{ value: identifierSubType.split('@@')[0]}]
            }
            const new_value_clone = [...props.value, newIdentifier]; 
            // Identifer count managed for iqvia profiles. specific number of identifiers are added. 
            let checkCountOfIqviaIdentifier = (Object.values(new_value_clone)?.filter((res)=> res.ManagedBy && res.ManagedBy[0].value === "IQVIA"))
            
            if( (props.source && props.source[0]?.value == 'VNDR-CGDM' || props.vendor =='IQVIA' ) && checkCountOfIqviaIdentifier.length > (props.entity == 'HCO' ? CONSTANT.IQVIA_HCO_IDENTIFIER_COUNT : CONSTANT.IQVIA_HCP_IDENTIFIER_COUNT)) {
                setModal({
                    flag: true,
                    success: false,
                    message: (props.entity == 'HCO' ? identifierPopUpMsg[0].iqviaHcoIdentifier.description : identifierPopUpMsg[0].iqviaHcpIdentifier.description ),
                    title: identifierPopUpMsg[0].iqviaHcoIdentifier.heading
                });
                setIdentifierSaved(false)
            }else{
                setIdentifierSaved(true)
                props.checkIdentifierSubmitted(addNewFlag,identifierType,identifierId,true)
                props.updatedValue(new_value_clone,true)
                setaddNewFlag(false)
                setIdentifierId('')
                setIdentifierType('')
                setIdentifierSubType('')
                setidlengthFlag()
                settypelengthFlag()
                setsubtypelengthFlag()
                setSnackBarMessage('Identifier successfully saved')
                setSnackbarOpen(true);
                props.checkIdentifierSubmitted(addNewFlag,identifierType,identifierId,true)
            }
        }
    }
    const deleteNewItem = () =>{
        setaddNewFlag(false)
        setIdentifierId('')
        setIdentifierType('')
        setIdentifierSubType('')
        setidlengthFlag()
        settypelengthFlag()
        setsubtypelengthFlag()
        setOldEffectiveEndDate('')
        setIdentifierSaved(false)
        props.checkIdentifierSubmitted(false,identifierType,identifierId,identifierSaved)
    }

    const findTypeOfIdentifier = (identifier) => {
        if(identifier.includes('@@Lilly Managed//')){
            return 'Lilly Managed- Unclassified'
        }
        else if(identifier.includes('@@Lilly Managed')){
            return 'Lilly Managed- Classified'
        }
        else if(identifier.includes('@@Vendor Managed//')){
            return 'Vendor Managed- Unclassified'
        }
        else if(identifier.includes('@@Vendor Managed')){
            return 'Vendor Managed- Classified' 
        }
        else if(identifier.includes('//')){
            return 'Unclassified'
        }
        else{
            return 'Classified'
        }
    }

    const handelInput = (event, passTo, reqFlag) => {         
        if (event.target.name === "Identifiers Id" && event.target.value != null)
        {
            setidlengthFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))   
            setIdentifierId(event.target.value) 
        }
        if (event.target.name === "Identifiers Type" && event.target.value != null)
        {
            settypelengthFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))   
            setIdentifierType(event.target.value) 
            if(event.target.value?.split('@@')[1] == 'Vendor Managed')
                {
                    setShowSubType(false)
                }
            else{
                setShowSubType(true)
            }
        }
        if (event.target.name === "Identifiers SubType" && event.target.value != null) 
        {
            setsubtypelengthFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))   
            setIdentifierSubType(event.target.value) 
        }
                props.checkIdentifierSubmitted(addNewFlag,identifierType,identifierId,identifierSaved)
        

    }
    const passToParent = async (event) => {
        
    }

    const goBack = () => {
        props.history.push('/')
    }


    const handleSnackbarClose = ()=>{
        setSnackbarOpen(false);
    }
    return (
         <div>
            <Snackbar
                open={snackbarOpen}
                onClose={handleSnackbarClose}
                autoHideDuration={2000}
                anchorOrigin={{horizontal:'center', vertical:'bottom'}}
            >
                <Paper sx={{padding: '15px 40px'}}>
                    <Typography className='_wg-dynamic-text' align='center'>{snackBarMessage}</Typography>
                </Paper>
            </Snackbar>
        {

        ((props.value && props.value.length > 0) || (props.mode === 'Edit'  && identifierTypeOption && identifierTypeOption.length > 0 ))
        &&
        // className={"shadow-md mt-2 col-12"}
        <Accordion square className={`${props.shadow?'shadow-md':'shadow-none'} mt-2 col-12`} expanded={accordian}>
            <AccordionSummary onClick={() => closeAccordian(accordian)}
                expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="IdentifiersView_AccordionSummary" 
                className='bg-grey'>
                    <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>{label}</Typography>
            </AccordionSummary>
            <AccordionDetails className=''>
                <div className=" container w-100 p-3 pt-0">
                    {
                    props.mode === 'Edit' && !addNewFlag  && identifierTypeOption && identifierTypeOption.length > 0 &&(
                    <Stack direction='row' alignItems='center'>
                        <IconButton size='small' sx={{backgroundColor:'var(--lilly-primary)', '&:hover':{background:'var(--lilly-primary)', opacity:'0.6'}}} onClick={()=> addNewNested(label)}>
                            <Add sx={{color:'white'}}/>
                        </IconButton>
                        <Typography marginLeft='10px' className='_wg-dynamic-text' variant='subtitle1'>Add New Identifier</Typography>
                    </Stack>
                    )
                    }
                    {
                        props.mode !== 'Viewing'  && addNewFlag === true && 
                        <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root} >
                            <Collapse in={true} timeout="auto" unmountOnExit>
                                <List component="div" className="bg-grey" >
                                    <ListItem className={classes.nested}>
                                        
                                        <div key={"Identifiers Type"} className='col-sm-12'>
                                        <span className="text-muted mb-2  mt-2 _wg-dynamic-text" >{"Type"}</span>
                                            <Autocomplete
                                                    value={identifierType}
                                                    key={"Identifiers Type"}
                                                    onChange={(event, value) => handelInput({ target: { value: value,"name":"Identifiers Type" } }, true)}
                                                    options={sortIdentifier(identifierTypeOption).flatMap(group => group.options ? sortTranslated(group.options) : sortTranslated(group))}
                                                    getOptionLabel={(option) => option?.includes('@@') ? option?.split('@@')[0] : option?.split('//')[0]}
                                                    groupBy={(option) => findTypeOfIdentifier(option)}
                                                    isOptionEqualToValue={(option, value) => option == value}                                                    
                                                    id={"Identifiers_Type"}
                                                    name={"Identifiers Type"}
                                                    multiple={false}
                                                    renderInput={(params) =>
                                                        <TextField {...params} error={(typelengthFlag)}
                                                        variant="standard" className='_wg-dynamic-text'
                                                            helperText={((typelengthFlag)) ? "Please Select One Option" : ""} />}
                                                />
                                        </div>
                                    </ListItem>
                                    {AltIDSubtype.length > 0 && showSubType &&                                    
                                    <ListItem className={classes.nested}>
                                            <div key={"Identifiers SubType"} className='col-sm-12'>
                                            <span className="text-muted mb-2  mt-2 _wg-dynamic-text">{"Sub Type"}</span>
                                                <Autocomplete
                                                        value={identifierSubType}
                                                        key={"Identifiers SubType"}
                                                        onChange={(event, value) => handelInput({ target: { value: value,"name":"Identifiers SubType" } }, true)}
                                                        options={sortIdentifier(AltIDSubtype).flatMap(group => group.options ? sortTranslated(group.options) : sortTranslated(group))}
                                                        groupBy={(option) => findTypeOfIdentifier(option)}
                                                        getOptionLabel={(option) =>  option?.includes('@@') ? option?.split('@@')[0] : option?.split('//')[0]}
                                                        isOptionEqualToValue={(option, value) => option == value}
                                                        id={"Identifiers_SubType"}
                                                        name={"Identifiers SubType"}
                                                        multiple={false}
                                                        renderInput={(params) =>
                                                            <TextField {...params} error={(subtypelengthFlag) }
                                                            variant="standard" className='_wg-dynamic-text'
                                                                helperText={((subtypelengthFlag) ) ? "Please Select One Option" :''} />}
                                                    />
                                            </div>
                                    </ListItem>
                                      }
                                    <ListItem className={classes.nested} >
                                        <div key={"Identifiers Id"} className='col-sm-12 _wg-dynamic-text'>
                                        <span className="text-muted mb-2  mt-2">Id</span>
                                            <TextField
                                                type={"text"}
                                                key={"Identifiers Id"}
                                                helperText={((idlengthFlag)) ? "Please Enter Something" : " "}
                                                value={identifierId || ''}
                                                onChange={handelInput}
                                                onBlur={passToParent}
                                                id={"Identifiers_Id"}
                                                variant="standard"
                                                name={"Identifiers Id"}
                                                color="primary" className="w-100" />
                                        </div>
                                    </ListItem>
                                </List>
                            </Collapse>
                            <Stack spacing={1} alignItems='center' direction='row' justifyContent='flex-end'>
                                <Button
                                    sx={{color:'gray', "&:hover":{background:"rgba(134,136,138,0.05)"}}}
                                    size='small' 
                                    className='_wg-dynamic-text'
                                    onClick={deleteNewItem} 
                                >Cancel</Button>
                                <Button 
                                    sx={{
                                        color:'var(--lilly-primary)',
                                        transition:'100ms background linear',
                                        "&:hover": {backgroundColor: 'rgba(219, 28, 28,0.05)'},//override mui hover
                                    }} 
                                    size='small'
                                    className='_wg-dynamic-text'
                                    onClick={saveNewIteam} 
                                >Save</Button>
                            </Stack>
                        </List>
                    }
                {
                    identifierValue?.map((element, i) => {
                        let partHeadingArray = props.heading.split('&');
                        if (partHeadingArray.length > 1) {
                            let newAddedValue = element["AddedNew"] ? true:false
                            let newLabel = '';
                            let visitedFirst = true;
                            partHeadingArray.forEach((labelElement, i) => {
                                let arrayValue = element[labelElement];
                                if (arrayValue !== undefined && arrayValue.length > 0 && arrayValue[0].value !== undefined) {
                                    newLabel += (visitedFirst ? arrayValue[0].value : ' ' + arrayValue[0].value);
                                    visitedFirst = false;
                                } else {
                                    newLabel = '<No Label >';
                                }

                                    });
                            return (
                             props.heading &&

                                <ListView
                                    oldEffectiveEndDate={  oldEffectiveEndDate !== "" && oldIdentifierValue[i]?.udpateFlag ? oldEffectiveEndDate: ''}
                                    entity={props.entity}
                                    mode={props.mode}
                                    newAddedValue = {newAddedValue}
                                    key={i}
                                    index= {i}
                                    change={changedFlag}
                                    error={error}
                                    label={newLabel}
                                    value={element}
                                    deleteItemFromList={(deleteItem) => deleteItemFromList(deleteItem)}
                                    updateValue = {(value, flag,key )=> updateValue(value, flag, key)}
                                    deletePreviousChange = {(index)=> deletePreviousChange(index)}
                                    saveUpdatedIdentifier = {(index)=> saveUpdatedIdentifier(index)}
                                    noDataInIdentitifer = {(msg)=>noDataInIdentitifer(msg)}
                                    oldValue = {(props.oldValue && props.oldValue[i] !== undefined) ? props.oldValue[i] : []}
                                    profileSource = {props.source}
                                />)
                            }

                        })
                    }
                </div>
                {
            modal.flag
            &&
            <Popup
                closePopup={() => { setModal(false) }}
                open={modal.flag}
                success={modal.success}
                message={modal.message}
                title={modal.title}
                typeHCP={true}
                addNewHCP={true}
                close={() => { setModal(false); goBack() }}
                    />
                }
            </AccordionDetails>
        </Accordion >
        }
        </div> 
    );
}
export default IdentifiersView; 
